/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { RolePlusLoot, RolePlusLootInterface } from "../RolePlusLoot";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lootId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "petId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "roleId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "imageUrl",
        type: "string",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "imageUrl",
        type: "string",
      },
    ],
    name: "setImageUrl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class RolePlusLoot__factory {
  static readonly abi = _abi;
  static createInterface(): RolePlusLootInterface {
    return new utils.Interface(_abi) as RolePlusLootInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RolePlusLoot {
    console.log(
      "🚀 ~ file: RolePlusLoot__factory.ts ~ line 606 ~ RolePlusLoot__factory ~ address",
      address
    );
    return new Contract(address, _abi, signerOrProvider) as RolePlusLoot;
  }
}
